"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.steamController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const appType_1 = require("../../../contracts/generated/Enum/appType");
const steamController = (service) => {
    const _appTypes = [appType_1.AppType.nms, appType_1.AppType.sms];
    const readBranch = (appType) => __awaiter(void 0, void 0, void 0, function* () {
        const branchesResult = yield service.get(`${endpoints_1.endpoints.steamBranches}/${appType}`);
        return Object.assign(Object.assign({}, branchesResult), { value: {
                appType: appType_1.AppType[appType],
                branches: branchesResult.value,
            } });
    });
    return ({
        readNews: (appType) => {
            return service.get(`${endpoints_1.endpoints.steamNews}/${appType}`);
        },
        readBranch,
        readAllBranches: () => __awaiter(void 0, void 0, void 0, function* () {
            const result = [];
            for (const appType of _appTypes) {
                const localBranch = yield readBranch(appType.toString());
                if (localBranch.isSuccess) {
                    result.push(localBranch.value);
                }
            }
            return {
                isSuccess: true,
                value: result,
                errorMessage: '',
            };
        }),
        updateBranch: (appType, item) => {
            return service.put(`${endpoints_1.endpoints.steamBranches}/${appType}`, {
                newData: item.branches
            }, service.addAccessTokenToHeaders);
        },
    });
};
exports.steamController = steamController;
